import Vue from 'vue'
import Router from 'vue-router'
 
import Main from '../views/Main'
import committeeMain from '../views/committee'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);
 
export default new Router({
  mode: 'history', // 设置路由模式
  base: 'carec',
  routes: [
    {
      // 首页
      path: '',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          component: resolve => require(['../components/word/Index.vue'], resolve),
          meta: {title: '首页'},
        },
        {
          path: 'Content',
          name: 'Content',
          component: resolve => require(['../components/word/Content.vue'], resolve),
          meta: {title: '相关信息'},
        },
        {
          path: 'Construct',
          name: 'Construct',
          component: resolve => require(['../components/word/construct.vue'], resolve),
          meta: {title: '建设中'},
        },
        {
          path: 'GroupStandardDeclarationDownload',
          name: 'GroupStandardDeclarationDownload',
          component: resolve => require(['../components/word/GroupStandardDeclarationDownload.vue'], resolve),
          meta: {title: '团体标准申报'},
        },
        {
          path: 'Search',
          name: 'Search',
          component: resolve => require(['../components/word/Search.vue'], resolve),
          meta: {title: '关键字搜索'},
        }
      ],
    },
    {
      // 委员会首页
      path: '/committee',
      name: 'committee',
      component: committeeMain,
      children: [
        {
          path: '/',
          component: resolve => require(['../components/word/committeeIndex.vue'], resolve),
          meta: {title: '首页'},
        },
        {
          path: 'Content',
          component: resolve => require(['../components/word/committeeContent.vue'], resolve),
          meta: {title: '相关信息'},
        }
      ],
    }
   
  ]
});